import { useQuery } from '@tanstack/react-query';
import queryString from 'query-string';

import { API_CUSTOM_SEGMENTS_AI_SEARCH_URL } from '../constants/apiUrls';
import { getRequestJSON } from '../util/services';
import { useConfig } from './useConfig';

export interface EsriResult {
  audience_id: string;
  similarities: number;
  audience_type: string;
  description: string;
  type: string;
  expanded_description?: string;
}

export interface SegmentResult {
  audience_id: string;
  similarities: number;
  audience_type: string;
  segment_name: string;
  description: string;
  segment_price?: string | null;
  segment_size?: string | null;
}

export interface DemographicResult {
  attribute_name: string;
  description: string;
  type: string;
  expanded_description?: string;
}

export interface LiverampResult {
  segment_id: string;
  similarities: number;
  description: string;
  price?: number;
  segment_desc_expanded?: string;
}

export interface AiAudienceSearchResponse {
  demographic: DemographicResult[];
  esri: EsriResult[];
  segments: SegmentResult[];
  liveramp: LiverampResult[];
  elaborated_audience_description?: string;
}

function useAiAudienceSearch(textQuery: string, topN = 10) {
  const { apiHost } = useConfig();
  return useQuery<AiAudienceSearchResponse>({
    queryKey: ['aiAudienceSearch', textQuery, topN],
    queryFn: () =>
      getRequestJSON(
        apiHost,
        `${API_CUSTOM_SEGMENTS_AI_SEARCH_URL}?${queryString.stringify({
          text_query: textQuery,
          top_n: topN,
        })}`
      ),
    enabled: textQuery.trim().length > 0,
    retry: false,
  });
}

export default useAiAudienceSearch;
